export * from './cidade.service';
export * from './estado.service';
export * from './pais.service';
export * from './loggedin.guard';
export * from './usuario.service';
export * from './login.service';
export * from './log.service';
export * from './auth.interceptor';
export * from './loader.interceptor';
export * from './loader.service';

export * from './turismo/aereo.service';
export * from './turismo/aeroporto.service';
export * from './turismo/hotel.service';
export * from './turismo/seguro.service';
export * from './turismo/servico.service';
export * from './turismo/reserva.service';
export * from './turismo/financiamento.service';
export * from './turismo/voucher.service';

export * from './cadastro/empresa.service';
export * from './cadastro/agencia.service';

export * from './gerenciamento/hoteloffline.service';
export * from './gerenciamento/servicooffline.service';
export * from './gerenciamento/servicoofflinefornecedor.service';
export * from './gerenciamento/servicoofflinetarifa.service';
export * from './gerenciamento/servicoofflinetarifafaixaetaria.service';
export * from './gerenciamento/servicoofflinepergunta.service';
export * from './gerenciamento/servicoofflineperguntaopcao.service';
export * from './gerenciamento/categoriaapartamentooffline.service';
export * from './gerenciamento/apartamentooffline.service';
export * from './gerenciamento/webservice.service';
export * from './gerenciamento/perfilmarkup.service';
export * from './gerenciamento/markup.service';
export * from './gerenciamento/cachehotel.service';
export * from './gerenciamento/moeda.service';
export * from './gerenciamento/subfornecedor.service';
export * from './gerenciamento/cambio.service';
export * from './gerenciamento/markdown.service';
export * from './gerenciamento/forma-pagamento.service';
export * from './gerenciamento/condicao-pagamento.service';
export * from './gerenciamento/offlinehotelmanutencaoperiodo.service';
export * from './gerenciamento/offlinehotelpromocaotarifa.service';
export * from './gerenciamento/offlinehotelregratarifaria.service';
export * from './gerenciamento/bloqueioaereo.service';
export * from './gerenciamento/bloqueioaereovoo.service';
export * from './gerenciamento/televendaspagamento.service';

export * from './gerenciamento/tarifacategoriaapartamentooffline.service';

export * from './configuracao/perfil-usuario.service';
export * from './configuracao/permissao.service';
export * from './configuracao/parametro.service';
export * from './configuracao/profissao.service';

import { Injectable } from '@angular/core';

import { API } from '../app.config';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class Util {

  
  constructor() { }
  static translate: TranslateService
  
  static pathImagemApi(nome: string): string {
    if (nome == null || nome == undefined || nome.length == 0) {
      return `/assets/img/notfound.jpg`;
    } else {
      return `${API}${nome}`;
    }

  }


  static fazerTraducao(texto: string): string {
    try {
      return this.translate.instant(texto);
    } catch (e) {
      console.log(e);
      return texto;
    }
  }
}
